var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"displayCard"}},[_c('v-card',{staticClass:"mb-12 myCollectionCard",attrs:{"min-height":"85vh"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("navNotification")))]),_c('notifications')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }